export default {
  "content": "<g clip-path=\"url(#clip0_691_52248)\"><path d=\"M13.927 4.98a6.001 6.001 0 10-11.12 4l4.146 6.42a1.247 1.247 0 002.1 0l4.154-6.42a6 6 0 00.72-4zM8 9.333a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667z\" fill=\"#FA4338\"/></g><defs><clipPath id=\"clip0_691_52248\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};